import React, { useState, useEffect } from "react";
import { TopSection } from "./TopSection";
import { MarketGuest } from "./MarketGuest";
import { Provider } from "react-redux";
import store from "../../store/store";
import { CartGuest } from "./CartGuest";
import { toast, ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import FormModal from "../../Components/Form";
import "react-calendar/dist/Calendar.css";
import { useParams } from "react-router-dom";
import useUser from "../../Context/hook/useUser";
import { useQuery } from "react-query";
import axios from "axios";
import { loadSessionUser, postRequest } from "../../Services/axios.service";
import { ENVIAR_PAGO, ENVIAR_PAGO_GUEST } from "../../Utils/url.api";
import { URL } from "../../Utils/url.api";
import { useDispatch } from "react-redux";
import { uiActions } from "../../store/ui";
import { datePipe } from "../../Utils/pipes";
import { useQueries } from "react-query";
import { filterActions } from "../../store/filter";
function SistemaCompraGuest(props) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { getUser } = useUser();
  const [loading, setLoading] = useState(false);
  const [loadingImage, setLoadingImage] = useState(false);
  const cart = useSelector((state) => state.cart.cart);
  const [cardNetForm, setCardNetForm] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const imageFilterr = useSelector((state) => state.filter.imagesId);
  const  tipoImagen = "ImagenPerfil";
  const fechaActual = new Date();
  const fetchParkById = async () => {
    return await axios.get(URL + `Parque/ObtenerParqueSinImagenesId/${id}`);
  };
  // const fetchImageParkById = async () => {
  //   return await axios.get(URL + `Parque/ObtenerImagenParqueId/${id}/${tipoImagen}`);
  // };
  const getImagesId = async () => {
    try {
      const response = await axios.get(URL + 'Parque/ObtenerImagenParqueId', {
        params: {
          id: id,
          tipoImagen: tipoImagen
        }
      });
      dispatch(
        filterActions.defaultValues({
          values: response.data.data,
          method: "imageId",
        })
      );
      //return response.data.data;
    } catch (error) {

      console.error('Error al obtener las imágenes:', error);
    }
  };
  
    const queryResultsss = useQueries([
  
      {
        queryKey: "imageId",
        queryFn: getImagesId,
      },
    ]);

  useEffect(() => {
    if (cardNetForm) {
      document.getElementById("cardnetPagoForm").submit();
    }
  }, [cardNetForm]);

  const { isLoading, data: data1 } = useQuery("parkId", fetchParkById);
  //const {  data: dataImage } = useQuery("imageparkId", fetchImageParkById);
  
  const finishPayment = async (info) => {
   
    const payModel = {
      parqueId:data1.data.data.id,
      name: info.name,
      email: info.email,
      phoneNumber: info.phone,
      detalleCompra: [
        {
          cantidad: 1,
          fechaValid: fechaActual.toISOString()
        },
      ],
    };
    console.log(payModel);
    setShowModal(false);
    setLoading(true);
    const { data, status } = await postRequest(ENVIAR_PAGO_GUEST, payModel);
    setLoading((cur) => false);
    if (data && status == 200) {
      setCardNetForm(data);
    } else if (status != 200 && data?.Message) {
      const formatMessage = String(data?.Message).split("- - ->")[1];
      toast.warning(formatMessage ?? data?.Message, {
        autoClose: 10000,
        position: "top-center",
        theme: "colored",
      });
    }
  };

  const sendPayment = () => {
    setShowModal(true);
  };

  if (isLoading) {
    dispatch(uiActions.ladingStatus({ conditional: true }));
    return "";
  } else {
    dispatch(uiActions.ladingStatus({ conditional: false }));
  }

  return (
    <Provider store={store}>
      <FormModal isOpen={showModal} onClose={finishPayment} />
      <div className="py-20 px-10">
        {loading && <div className="line-loading"></div>}
        <ToastContainer />
        <div dangerouslySetInnerHTML={{ __html: cardNetForm }} />
        <TopSection id={id} />
        <div className="flex justify-around flex-wrap gap-x-8 gap-y-16 mt-4 tab-port:mt-20">
          <MarketGuest id={id} park={data1.data.data} imageFilter={imageFilterr} />
          <CartGuest sendPayment={sendPayment} id={id} park={data1.data.data} />
        </div>
      </div>
    </Provider>
  );
}

export default SistemaCompraGuest;
